export const validatorsKeys = {
  base: ["validators"],
  list: (params: Record<string, unknown>) => [...validatorsKeys.base, "list", params],
};
